/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-07-30 10:33:36
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-07-30 10:39:06
 * @FilePath: \baishu_react_ui\src\components\BsyMaskLayer\dlg.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";

import './index.css'


export default class Dlg extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }
 
    close = () => {
        this.props.onRemoveRoot()
    }

    _renderContent() {
        if (this.props.onContentCreate) {
            return this.props.onContentCreate(this);
        } else {
            return ''
        }

    }

    render() {

        return (
            this._renderContent()
        )
    }
}

// Dlg.defaultProps = {
//     okText: React.language("ok"), 
//     onOk:null,
//     cancelText: React.language("cancel"),
//     onCancel:null,
// }